import React, { Component } from "react";
import "../Settings/SubNavbar.css";
import { post, get } from "../../custom_libraries/serverRequests";
import globalVariables from "../../custom_libraries/globalVariables";
import urls from "../../custom_libraries/urls";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Switch,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import Backdrop from "@mui/material/Backdrop";
import WebLogo from "../../assets/Artboard 1Bonus.png";

//-------------dark theme-------------------------------------
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#191e29",
      paper: "#2f3541",
    },
    text: {
      primary: "#ffffff",
      secondary: "#bbbbbb",
    },
  },
});
//------------------------------------------

class DeviceLevelRocketChat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      success: false,
      warning: false,
      response_message: "",
      open_progress_bar: false,
      deviceId: "",
      // Mirrors the API field names: channel_name, rocket_chat
      rocket_chat_device_settings: {
        channel_name: "",
        rocket_chat: false,
      },
    };
    this.alertTimer = null;
  }

  componentDidMount() {
    const deviceId = localStorage.getItem(globalVariables.DEVICE_ID);
    this.setState({ deviceId });
    this.fetchUserSettings(deviceId);
  }

  componentDidUpdate(prevProps, prevState) {
    const { error, success, warning } = this.state;
    if (
      (error !== prevState.error ||
        success !== prevState.success ||
        warning !== prevState.warning) &&
      (error || success || warning)
    ) {
      clearTimeout(this.alertTimer);
      this.alertTimer = setTimeout(() => {
        this.setState({
          error: false,
          success: false,
          warning: false,
          response_message: "",
        });
      }, 3000);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.alertTimer);
  }

  getHeaders = () => ({
    "content-type": "application/json",
    Authorization: `Bearer ${localStorage.getItem(globalVariables.AUTH_TOKEN)}`,
  });

  handleChannelNameChange = (value) => {
    this.setState((prev) => ({
      rocket_chat_device_settings: {
        ...prev.rocket_chat_device_settings,
        channel_name: value,
      },
    }));
  };

  handleToggle = () => {
    this.setState((prev) => ({
      rocket_chat_device_settings: {
        ...prev.rocket_chat_device_settings,
        rocket_chat: !prev.rocket_chat_device_settings.rocket_chat,
      },
    }));
  };

  // GET response: { device_id, channel_name, rocket_chat, created_at, updated_at }
  fetchUserSettings = async (devId) => {
    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
      // console.log("--------auth tocken---------", access_tocken);
      let headers = {
        // 'content-type': 'application/json',
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${access_tocken}`,
      };

      this.startLoading();
      const response = await get(
        urls.GET_ROCKET_CHAT_DEVICE_SETTINGS(devId), headers
      );

      if (response && response.error) {
        this.setState({ error: true, response_message: response.error });
        return;
      }

      this.setState({
        rocket_chat_device_settings: {
          channel_name: response?.channel_name ?? "",
          rocket_chat: Boolean(response?.rocket_chat),
        },
      });
    } catch (err) {
      console.error("Error fetching settings:", err);
      this.setState({
        error: true,
        response_message: "Error fetching settings. Please try again.",
      });
    } finally {
      this.stopLoading();
    }
  };

  // POST payload: { device_id, channel_name, rocket_chat }
  handleSave = async () => {
    const { rocket_chat_device_settings, deviceId } = this.state;

    const payload = {
      device_id: Number(deviceId),
      channel_name: rocket_chat_device_settings.channel_name,
      rocket_chat: rocket_chat_device_settings.rocket_chat,
    };

    try {
      this.startLoading();
      const response = await post(
        urls.ROCKET_CHAT_DEVICE_SETTINGS,
        JSON.stringify(payload),
        this.getHeaders(),
      );

      if (response && response.message) {
        this.setState({ success: true, response_message: response.message });
        this.fetchUserSettings(deviceId); // refresh UI from server
      } else {
        this.setState({
          error: true,
          response_message:
            response?.error || "Error saving the settings. Please try again.",
        });
      }
    } catch (err) {
      console.error("Error saving settings:", err);
      this.setState({
        error: true,
        response_message: "Error saving the settings. Please try again.",
      });
    } finally {
      this.stopLoading();
    }
  };

  startLoading = () => {
    this.setState({ open_progress_bar: true });
  };

  stopLoading = () => {
    this.setState({ open_progress_bar: false });
  };

  render() {
    const {
      error,
      success,
      warning,
      response_message,
      rocket_chat_device_settings,
    } = this.state;

    return (
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <Box sx={{ backgroundColor: "#323744" }}>
          <Box
            className="setting-container"
            style={{ width: "93%", alignItems: "center" }}
          >
            <div style={{ width: "100%" }}>
              {error ? (
                <Alert severity="error">{response_message}</Alert>
              ) : success ? (
                <Alert
                  icon={<CheckIcon fontSize="inherit" />}
                  severity="success"
                >
                  {response_message}
                </Alert>
              ) : warning ? (
                <Alert severity="warning">{response_message}</Alert>
              ) : null}
            </div>

            <Box
              component={Paper}
              style={{
                display: "flex",
                fontSize: "13px",
                justifyContent: "space-between",
                marginBottom: "20px",
                width: "100%",
                border: "1px solid #ffffff36",
                borderRadius: "5px",
              }}
            >
              <div style={{ padding: "5px" }}>
                <h4>Steps to follow:</h4>
                - Add Channel ID for receiving updates on rocket chat
                <br />
                - You can enable/disable notifications as needed by toggling the
                switch.
                <br />
              </div>
              <div style={{ padding: "8px" }}>
                <h4>Settings Info.</h4>
                <b>- </b>Alerts of this device's cameras rated by the operator
                are notified on the added channel
                <br />
                <b>- </b>No notifications will be sent if the switch is toggled
                off
                <br />
              </div>
            </Box>

            <div style={{ width: "100%" }}>
              <TableContainer
                component={Paper}
                sx={{
                  backgroundColor: "#303640",
                  border: "1px solid #ffffff36",
                  borderRadius: "5px",
                }}
              >
                <Table style={{ tableLayout: "auto", width: "100%" }}>
                  <TableHead>
                    <TableRow>
                      {[
                        { label: "Channel Name", id: "h-rec" },
                        { label: "Enable Feature?", id: "h-chm" },
                      ].map((header) => (
                        <TableCell key={header.id}>
                          <Typography variant="subtitle2" fontWeight="bold">
                            {header.label}
                          </Typography>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* One record per device, so a single row (no .map) */}
                    <TableRow>
                      <TableCell>
                        <input
                          type="text"
                          className="input-email"
                          value={rocket_chat_device_settings.channel_name}
                          onChange={(e) =>
                            this.handleChannelNameChange(e.target.value)
                          }
                          placeholder="Enter channel name"
                          style={{ width: "280px" }}
                        />
                      </TableCell>
                      <TableCell>
                        <Switch
                          checked={rocket_chat_device_settings.rocket_chat}
                          onChange={this.handleToggle}
                          color="primary"
                          size="medium"
                        />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>

              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  id="rowsPerPageButton"
                  style={{ marginTop: "12px" }}
                  onClick={this.handleSave}
                >
                  Save
                </Button>
              </div>
            </div>
          </Box>

          {/* Backdrop with spinner */}
          <Backdrop open={this.state.open_progress_bar}>
            <div className="custom-spinner">
              <div className="circle"></div>
              <div className="circle tilted"></div>
              <img
                src={WebLogo}
                alt="web-logo"
                style={{ backgroundColor: "#001f54", borderRadius: "100px" }}
              />
            </div>
          </Backdrop>
        </Box>
      </ThemeProvider>
    );
  }
}

export default DeviceLevelRocketChat;